// Die festen Datenlisten aus `daten/` – die Ebene „Happy Energy“, die in
// Stufe 1 noch keine Tabelle ist (PLAN.md, Abschnitt 4). Daten statt Code:
// Wer eine Station umbenennt, ändert die JSON-Datei, nicht das Programm.

import stationenDatei from "../../../daten/stationen.json" with { type: "json" };
import laengenDatei from "../../../daten/laengen-arten.json" with { type: "json" };
import kistenDatei from "../../../daten/kisten.json" with { type: "json" };
import produktlinienDatei from "../../../daten/produktlinien.json" with { type: "json" };

export interface Station {
  nr: number;
  schluessel: string;
  name: string;
  kurz: string;
  erklaer: string;
}

export interface LaengenArt {
  schluessel: string;
  name: string;
  einheit: string;
}

export type KistenStufe = "s1" | "teil" | "spaeter";

export interface Kiste {
  schluessel: string;
  name: string;
  wer: string;
  stufe: KistenStufe;
}

export interface Produktlinie {
  schluessel: string;
  name: string;
  aktiv: boolean;
}

export const STATIONEN: readonly Station[] = stationenDatei.stationen;
export const LAENGEN_ARTEN: readonly LaengenArt[] = laengenDatei.arten;
export const KISTEN: readonly Kiste[] = kistenDatei.kisten as Kiste[];
export const PRODUKTLINIEN: readonly Produktlinie[] = produktlinienDatei.produktlinien;

export const STATION_SCHLUESSEL = STATIONEN.map((s) => s.schluessel);
export const LAENGEN_SCHLUESSEL = LAENGEN_ARTEN.map((l) => l.schluessel);
export const KISTEN_SCHLUESSEL = KISTEN.map((k) => k.schluessel);
export const PRODUKTLINIEN_SCHLUESSEL = PRODUKTLINIEN.map((p) => p.schluessel);
